import { isWellFormedAppTranslationValue } from '../app-ui-settings/translation.js';
export const UI_CONFIG_TEXT_LANGUAGES = ['ko', 'en', 'vi'];
export const UI_CONFIG_EDITABLE_TEXT_LANGUAGES = ['ko'];
export const UI_CONFIG_TEXTS_MAX_ENTRIES = 3000;
const TRANSLATION_KEY = /^[\w-]+(?:\.[\w-]+)*$/;
const TRANSLATION_KEY_MAX_LENGTH = 200;
const isTree = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isTranslationKey = (key) => key.length <= TRANSLATION_KEY_MAX_LENGTH && TRANSLATION_KEY.test(key);
const isText = (value) => isWellFormedAppTranslationValue(value) && value !== '';
export function validateTextsPayload(language, payload) {
    const name = `text.${language}`;
    if (!isTree(payload))
        return { ok: false, errors: [`${name}: must be an object`] };
    const entries = Object.entries(payload);
    const errors = [];
    if (entries.length > 0 && !UI_CONFIG_EDITABLE_TEXT_LANGUAGES.includes(language))
        errors.push(`${name}: only Korean texts are changed on the server — this file stays empty`);
    if (entries.length > UI_CONFIG_TEXTS_MAX_ENTRIES)
        errors.push(`${name}: at most ${UI_CONFIG_TEXTS_MAX_ENTRIES} texts`);
    const texts = {};
    for (const [key, value] of entries) {
        if (!isTranslationKey(key))
            errors.push(`${key}: not a translation key`);
        else if (!isText(value))
            errors.push(`${key}: text must be 1–500 characters, no surrounding spaces or control characters`);
        else
            texts[key] = value;
    }
    return errors.length ? { ok: false, errors } : { ok: true, payload: texts, errors };
}
export function mergeTextsPayload(_builtIn, received) {
    if (!isTree(received))
        return null;
    const texts = {};
    for (const [key, value] of Object.entries(received))
        if (isTranslationKey(key) && isText(value))
            texts[key] = value;
    return texts;
}
//# sourceMappingURL=texts.js.map